module.exports = __webpack_public_path__ + "static/media/3.ca027ab8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/buy/3.png
// module id = 971
// module chunks = 0